import { __decorate } from "tslib";
import _ from 'lodash';
import Vue from 'vue';
import Component from 'vue-class-component';
import ConfirmDialog from "@/components/ConfirmDialog.vue";
let CrudComponent = class CrudComponent extends Vue {
    // These needs to be overwritten in the descendant
    storeModule;
    formAddTitle;
    formEditTitle;
    headers;
    defaultItem;
    editedItem = {};
    search = '';
    dialog = false;
    sending = false;
    datePicker = [];
    created() {
        this.editedItem = _.cloneDeep(this.defaultItem);
    }
    get getAllAction() {
        return this.storeModule + '/all';
    }
    get destroyAction() {
        return this.storeModule + '/destroy';
    }
    get storeAction() {
        return this.storeModule + '/store';
    }
    get updateAction() {
        return this.storeModule + '/update';
    }
    get formTitle() {
        return this.editedItem.id === this.defaultItem.id
            ? this.formAddTitle
            : this.formEditTitle;
    }
    get allItems() {
        return this.$store.getters[this.getAllAction];
    }
    closeDialog() {
        this.dialog = false;
        this.$emit('closed');
    }
    editItem(item) {
        this.resetValidation();
        this.editedItem = _.cloneDeep(item);
        this.dialog = true;
    }
    resetValidation() {
        for (let refKey of Object.keys(this.$refs)) {
            let textField = this.$refs[refKey];
            if (typeof textField !== 'undefined' && typeof textField[0] !== 'undefined') {
                textField[0].resetValidation();
            }
        }
    }
    validateForm() {
        let valid = true;
        for (let refKey of Object.keys(this.editedItem.data)) {
            if (typeof this.$refs[refKey] === 'undefined') {
                continue;
            }
            let textField = Object.values(this.$refs[refKey])[0];
            if (typeof textField !== 'undefined' && !textField.validate(true)) {
                valid = false;
            }
        }
        return valid;
    }
    async deleteItem(item) {
        if (await ConfirmDialog.open('Upozornění', 'Opravdu chcete smazat tuto položku?')) {
            await this.$store.dispatch(this.destroyAction, item);
        }
    }
    async save() {
        if (!this.validateForm()) {
            return;
        }
        this.sending = true;
        if (this.editedItem.id === this.defaultItem.id) {
            await this.$store.dispatch(this.storeAction, this.editedItem);
            this.$emit('stored', this.editedItem);
        }
        else {
            await this.$store.dispatch(this.updateAction, this.editedItem);
            this.$emit('updated', this.editedItem);
        }
        this.closeDialog();
        this.$emit('saved', this.editedItem);
        this.sending = false;
    }
};
CrudComponent = __decorate([
    Component
], CrudComponent);
export default CrudComponent;
